"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardRewardsImageRatios = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _CardContainer = _interopRequireDefault(require("../cardContainer/CardContainer"));

var _Image = _interopRequireDefault(require("../../../atoms/images/image/Image"));

var _ThirdPartyIcon = _interopRequireDefault(require("../../../protons/icons/ThirdPartyIcon"));

var _Typography = _interopRequireDefault(require("../../../protons/typography/Typography"));

var _CardContent = _interopRequireDefault(require("../cardContainer/CardContent"));

var _ButtonText = _interopRequireDefault(require("../../../atoms/buttons/buttonText/ButtonText"));

var _BoxPosition = _interopRequireDefault(require("../../../layouts/box/boxPosition/BoxPosition"));

var _BoxSizing = _interopRequireDefault(require("../../../layouts/box/boxSizing/BoxSizing"));

var _BadgeText = _interopRequireWildcard(require("../../../atoms/badges/badgeText/BadgeText"));

var _Favourite = _interopRequireDefault(require("../../../atoms/controls/favourite/Favourite"));

var _AppTheme = _interopRequireDefault(require("../../../../AppTheme"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardRewards = function CardRewards(_ref) {
  var imageSrc = _ref.imageSrc,
      imageRatio = _ref.imageRatio,
      textPrimary = _ref.textPrimary,
      badgeText = _ref.badgeText,
      badgeColor = _ref.badgeColor,
      textLink = _ref.textLink,
      icon = _ref.icon,
      isFavourite = _ref.isFavourite,
      onClick = _ref.onClick,
      _onChange = _ref.onChange;
  var media = (0, _core.useMediaQuery)(_AppTheme.default.breakpoints.down('xs'));
  return /*#__PURE__*/_react.default.createElement(_CardContainer.default, null, /*#__PURE__*/_react.default.createElement(_BoxPosition.default, {
    position: "relative"
  }, badgeText && /*#__PURE__*/_react.default.createElement(_BoxPosition.default, {
    position: "absolute",
    left: media ? "medium" : "large",
    top: media ? "medium" : "large"
  }, /*#__PURE__*/_react.default.createElement(_BadgeText.default, {
    text: badgeText,
    color: badgeColor
  })), /*#__PURE__*/_react.default.createElement(_BoxPosition.default, {
    position: "absolute",
    right: media ? "mini" : "small",
    top: media ? "mini" : "small"
  }, /*#__PURE__*/_react.default.createElement(_Favourite.default, {
    onChange: function onChange() {
      return _onChange();
    },
    checked: isFavourite
  })), /*#__PURE__*/_react.default.createElement(_BoxPosition.default, {
    position: "absolute",
    left: media ? "medium" : "large",
    bottom: media ? "medium" : "large"
  }, /*#__PURE__*/_react.default.createElement(_ThirdPartyIcon.default, {
    icon: icon
  })), /*#__PURE__*/_react.default.createElement(_Image.default, {
    ratio: imageRatio,
    src: imageSrc
  })), /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    bold: true,
    color: "VfGrey",
    component: "div",
    text: textPrimary,
    variant: "h3"
  }), /*#__PURE__*/_react.default.createElement(_BoxSizing.default, {
    pt: "mini"
  }, /*#__PURE__*/_react.default.createElement(_ButtonText.default, {
    action: function action() {
      return onClick();
    },
    title: textLink,
    icon: "ic_chevron__right",
    iconPos: "end"
  }))));
};

CardRewards.propTypes = {
  /** The image url to show */
  imageSrc: _propTypes.default.string.isRequired,
  imageRatio: _propTypes.default.oneOf(["4x3", "16x9"]),

  /** The primary text of the card */
  textPrimary: _propTypes.default.string.isRequired,

  /** The primary text of the card */
  badgeText: _propTypes.default.string,

  /** The primary text of the card */
  badgeColor: _propTypes.default.oneOf(_BadgeText.BadgeTextColors),

  /** The third party icon see #protons-icons-thirdparty--icon */
  icon: _propTypes.default.string,

  /** Links text */
  textLink: _propTypes.default.string.isRequired,

  /** The action of the card */
  onClick: _propTypes.default.func.isRequired,

  /** The action of the favourite button */
  onChange: _propTypes.default.func.isRequired,
  isFavourite: _propTypes.default.bool
};
CardRewards.defaultProps = {
  icon: null,
  badgeText: null,
  badgeColor: "white",
  imageRatio: "4x3",
  isFavourite: false
};
var CardRewardsImageRatios = ["4x3", "16x9"];
exports.CardRewardsImageRatios = CardRewardsImageRatios;
var _default = CardRewards;
exports.default = _default;